import { useEffect, useState } from "react"
import { SpinnerDiv, TabsPanel } from "../../../../../features/ui"
import { Tax } from "../../../state/types"
import { ListLoaderWrapper } from "../../../../../features/data-types"
import { TableName } from "../../../../../tables"
import { useTaxLoaders } from "../../../loaders/taxLoaders"
import { TaxList } from "./taxList"
import { IIBBPanel } from "../iibb-panel/iibbPanel"

const Loader = () => {
    const [taxes, setTaxes] = useState<Tax[]>([])
    const [ready, setReady] = useState(false)

    const taxLoaders = useTaxLoaders()

    const populate = async () => {
        const { loadAllTaxes } = taxLoaders()
        setTaxes(await loadAllTaxes(true))
    }

    useEffect(() => {
        populate().then(() => setReady(true))
    }, [])

    const tabs = [
        { id: 'taxes', title: 'Impuestos', content: ready ? <TaxList taxes={taxes} /> : <SpinnerDiv /> },
        { id: 'iibb', title: 'IIBB', content: <IIBBPanel /> }
    ]

    return <TabsPanel title="Impuestos" tabs={tabs} wide />
}

export const TaxListLoader = () => (
    <ListLoaderWrapper table={TableName.TAXES}>
        <Loader />
    </ListLoaderWrapper>
)
